module.exports = __webpack_public_path__ + "assets/media/2.a3f3e436.wav";